/* Animate only confirmed Dawn product additions; preserve the native cart flow. */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  let observer, pendingTimer, endTimer;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form' || event.cartData?.status || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    observer?.disconnect();
    clearTimeout(pendingTimer);
    const start = () => {
      observer?.disconnect();
      clearTimeout(pendingTimer);
      clearTimeout(endTimer);
      bubble.classList.remove('al-cart-adding');
      requestAnimationFrame(() => {
        void bubble.offsetWidth;
        bubble.classList.add('al-cart-adding');
        endTimer = setTimeout(() => bubble.classList.remove('al-cart-adding'), 1800);
      });
    };
    // The cart icon is replaced after the cartUpdate event, including quick-add.
    observer = new MutationObserver(start);
    observer.observe(bubble, { childList: true, subtree: true });
    pendingTimer = setTimeout(start, 700);
  });
})();
